import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPause } from '@fortawesome/free-solid-svg-icons'
import styles from './Media.module.css'


const Pause = (props: any) => {
    const { handleClick } = props;

    return (
        <button className={styles.playerButton} onClick={handleClick}>
            <FontAwesomeIcon icon={faPause} />
        </button>
    );
}

export default Pause
